import React, { useContext } from "react";
import { ThemeContext } from "../../lib/main-context";
import { useTranslation } from "../../i18n/TranslationProvider";

import { useHistory } from "react-router-dom";
import ReactECharts from "echarts-for-react";
import theme from "../../index.scss";

const DoughnutMedical = ({ data, days, userName, splitView }) => {
  const { dark } = useContext(ThemeContext);
  const { t } = useTranslation();
  const history = useHistory();

  const medicalData = data?.filter((obj) => obj.symptom_id !== 53);

  const subcategoryCount = medicalData?.reduce((acc, obj) => {
    const subcategory = obj.subcategory;
    acc[subcategory] = (acc[subcategory] || 0) + 1;
    return acc;
  }, {});

  const chartData = Object.keys(subcategoryCount).map((key) => ({
    value: subcategoryCount[key],
    name: key.charAt(0).toUpperCase() + key.slice(1),
  }));

  const handleChartClick = (params) => {
    history.push({
      pathname: "/MedicalDetailsChart",
      state: { medicalType: params.data.name, fromMedicalDetailsChart: true, days },
    });
  };

  const option = {
    title: {
      text: t("doughnutmedical.title"),
      subtext:
        chartData.length === 0
          ? `${t("notrackingdata.0")}\n${t("notrackingdata.1")}`
          : `${splitView ? `(${userName})` : ""}`,
      subtextStyle: { fontSize: "1.1rem", color: dark ? theme.darkModeText : theme.primary },
      left: "center",
      textStyle: { fontSize: "1.2rem", color: dark ? theme.darkModeText : theme.black },
    },
    grid: { top: "60px" },
    tooltip: {
      trigger: "item",
      formatter: (params) => {
        const percentage = params.percent.toFixed(1);
        const category = t(`symptomcategory.${params.name}`);
        return `${category}: ${percentage}%`;
      },
    },
    legend: { show: false, orient: "vertical", left: "left" },
    label: {
      show: true,
      fontSize: 16,
      color: dark ? theme.darkModeText : theme.black,
      formatter: (params) => {
        const percentage = params.percent.toFixed(1);
        const category = t(`symptomcategory.${params.name}`);
        return `${category}: ${percentage}%`;
      },
    },
    series: [{
      name: "Access From",
      type: "pie",
      radius: ["30%", "50%"],
      data: chartData,
      emphasis: {
        itemStyle: { shadowBlur: 10, shadowOffsetX: 0, shadowColor: "rgba(0, 0, 0, 0.5)" },
      },
    }],
  };

  return (
    <ReactECharts option={option} onEvents={{ click: handleChartClick }} style={{ minHeight: "25vh" }} />
  );
};

export default DoughnutMedical;